    {#if config.canEdit}
        <PageHeader title={headerText}
                    menuItems={optionItems}
                    i18n
                    buttonDropdownId={optionsSettingButton.id}
                    buttonDropdownText={optionsSettingButton.text}
                    responsiveDropdown={false}
                    on:selectedOption={selectedAction}
                    />
    {:else}
        <PageHeader title={headerText} />
     {/if}

    <Modal
        id="stop-sharing-planner-id"
        bind:enabled={showStopSharingPlannerConfirmModal}
        titleText={i18n.pleaseConfirm}
        bodyText={i18n.stopSiteSharing_ConfirmModalText}
        confirmText={i18n.yes}
        cancelText={i18n.no}
        confirmButtonType="primary"
        on:close={stopSharingModalClicked}
    />

<script>
    import Modal from "@itslearning/prometheus/assets/modals/Modal/v2/Modal.svelte";
    import Page from "@itslearning/prometheus/assets/templates/Page/v1/Page.svelte";
    import PageHeader from '@itslearning/prometheus/assets/patterns/PageHeader/v1/PageHeader.svelte';

    export let config;
    export let i18n;
    export let headerText = i18n.plansHeader;
    export let optionItems;
    export let selectedAction;
    export let showStopSharingPlannerConfirmModal;
    export let stopSharingModalClicked;

    const optionsSettingButton = {
        iconClass: "options-icon",
        iconOnly: true,
        id: "optionsdropdown",
        text: i18n.planSettings,
        textOnly: false,
        type: "secondary"
    };

</script>
